import React from "react";
import { CostsView } from "./EaPowerCosts";

export default function EaGasCosts() {
  return <CostsView commodity="GAS" />;
}
